<a id="navigator-link" class="navigator-parent navigator-label" (click)=clickParent() [routerLink]="'..'">{{parentLabel}}</a><span>&nbsp;&nbsp;</span>
<span id="navigator-icon" class="navigator-label">
    <fa-icon class="navigator-icon" [icon]="faAngleRight"></fa-icon>
</span>
<span id="navigator-label-text" class="navigator-label">&nbsp;&nbsp;{{elementLabel}}</span>
<mat-divider></mat-divider>